import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'ca-product-meta-tile',
    templateUrl: './product-meta-tile.component.html',
    styleUrls: ['./product-meta-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductMetaTileComponent {
    label = input.required<string>();
}
